<template>
    <common-content-spacer height="small" class="time-slots-selector">
        <common-page-header v-if="title" :isCenter="true" size="small" :heading="title"></common-page-header>
        <p class="time-slots-selector__date">{{ selcetedDaySlots?.date }}</p>
        <div class="time-slots-selector__inputs">
            <radio-input
                :direction="radioInputType"
                :options="timeOptions"
                :value="selectedTime"
                @change="setValue"
            ></radio-input>
        </div>
        <common-buttons>
            <common-button
                :isDisabled="!selectedTime"
                type="primary"
                size="tiny"
                :label="$t('common.microcopy.select')"
                :isFluid="true"
                @click="timeSelected"
            ></common-button>
        </common-buttons>
    </common-content-spacer>
</template>

<script>
    import RadioInput from 'components/form-inputs/RadioInput'
    import availabilityTransformer from 'transformers/availabilityTransformer'
    import WindowResizeMixin from 'mixins/WindowResizeMixin'
    import dayjs from 'dayjs'
    import timezone from 'dayjs/plugin/timezone'
    dayjs.extend(timezone)

    export default {
        mixins: [WindowResizeMixin],

        components: { RadioInput },

        props: {
            selcetedDaySlots: { type: Object, required: true },
            timeZone: { type: String, required: true },
            title: { type: String, default: null },
        },

        data() {
            return {
                selectedTime: null,
            }
        },

        computed: {
            timeOptions() {
                return this.selcetedDaySlots?.slots?.map((slot) => ({
                    value: JSON.stringify(slot),
                    label: `${availabilityTransformer.minutesDateToLocalTZTime(
                        slot.from,
                        this.selcetedDaySlots.date,
                        this.timeZone,
                    )} - ${availabilityTransformer.minutesDateToLocalTZTime(slot.to, this.selcetedDaySlots.date, this.timeZone)}`,
                }))
            },

            radioInputType() {
                return this.isTabletSmall ? 'column' : 'two-columns'
            },
        },

        methods: {
            setValue({ value }) {
                if (value) {
                    this.selectedTime = value
                }
            },
            timeSelected() {
                this.emitEvent({ name: 'time-selected', payload: JSON.parse(this.selectedTime) })
            },
        },

        watch: {
            timeOptions() {
                this.value = this.timeOptions[0].value
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import 'styles/components/availability/_time-slots-selector.scss';
</style>
